import React from 'react';
import Logo from './Logo';

const SecurityPage = ({ onBack }) => {
  return (
    <section id="security-page" className="min-h-screen bg-white">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <h1 className="text-xl font-bold text-primary">Keamanan Data</h1>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-24 bg-gray-50">
          <div className="px-4 py-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 space-y-6">
              
              {/* Header Section */}
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fa-solid fa-shield-alt text-primary text-3xl"></i>
                </div>
                <h2 className="text-2xl font-bold text-primary mb-2">Komitmen Keamanan Data</h2>
                <p className="text-gray-600">
                  Kami berkomitmen untuk melindungi privasi dan keamanan data Anda
                </p>
              </div>

              {/* Security Points */}
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-4 bg-green-50 rounded-xl">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-lock text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Enkripsi Data</h3>
                    <p className="text-sm text-gray-600">
                      Semua data pribadi Anda dienkripsi menggunakan teknologi keamanan terdepan untuk melindungi informasi sensitif.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-blue-50 rounded-xl">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-user-shield text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Privasi Terjamin</h3>
                    <p className="text-sm text-gray-600">
                      Kami tidak akan menyalahgunakan atau membagikan data pribadi Anda kepada pihak ketiga tanpa persetujuan Anda.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-yellow-50 rounded-xl">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-shield-check text-yellow-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Akses Terkontrol</h3>
                    <p className="text-sm text-gray-600">
                      Hanya tim yang berwenang yang dapat mengakses data Anda, dengan sistem autentikasi dan otorisasi yang ketat.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-purple-50 rounded-xl">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-database text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Penyimpanan Aman</h3>
                    <p className="text-sm text-gray-600">
                      Data Anda disimpan di server yang aman dengan backup rutin dan monitoring 24/7 untuk mencegah kehilangan data.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-red-50 rounded-xl">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fa-solid fa-ban text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">Tidak Akan Disalahgunakan</h3>
                    <p className="text-sm text-gray-600">
                      Kami berkomitmen penuh bahwa data pribadi Anda tidak akan digunakan untuk tujuan yang tidak sah atau merugikan Anda.
                    </p>
                  </div>
                </div>
              </div>

              {/* Additional Info */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <h3 className="font-bold text-primary mb-4">Kebijakan Privasi</h3>
                <div className="space-y-3 text-sm text-gray-600">
                  <p>
                    • Kami mengikuti standar keamanan data internasional dan regulasi perlindungan data pribadi Indonesia.
                  </p>
                  <p>
                    • Data Anda hanya digunakan untuk keperluan layanan dan tidak akan dijual atau dibagikan ke pihak ketiga.
                  </p>
                  <p>
                    • Anda memiliki hak untuk mengakses, memperbarui, atau menghapus data pribadi Anda kapan saja.
                  </p>
                  <p>
                    • Kami akan memberitahu Anda jika terjadi insiden keamanan yang mempengaruhi data Anda.
                  </p>
                </div>
              </div>

              {/* Contact Support */}
              <div className="mt-8 p-4 bg-primary/10 rounded-xl text-center">
                <p className="text-sm text-gray-700 mb-2">
                  Jika Anda memiliki pertanyaan tentang keamanan data atau privasi, silakan hubungi tim kami.
                </p>
                <button 
                  onClick={() => {
                    window.open('/#kontak', '_blank');
                  }}
                  className="mt-3 px-6 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition-colors text-sm font-semibold"
                >
                  <i className="fa-solid fa-envelope mr-2"></i>
                  Hubungi Tim Support
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </section>
  );
};

export default SecurityPage;

